import PropTypes from 'prop-types';
import React from 'react';
import cx from '../../utils/cx.js';

const ReactPropTypes = PropTypes;

class Loader extends React.Component {
	static propTypes = {
	  class: ReactPropTypes.string,
	};

	static defaultProps = {
	  class: '',
	  center: false,
	  large: false,
	};

	render() {
	  return (
  <div className={cx([
					'loader',
					['loader--center', this.props.center],
					['loader--large', this.props.large],
					this.props.class,
				])}
  >
    <div className="loader-icon" />
  </div>
	  );
	}
}

module.exports = Loader;
